import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IncidentFormControls } from 'src/app/types';

@Component({
  selector: 'app-review-form-suspected-theft',
  templateUrl: './review-form-suspected-theft.component.html',
  styleUrl: './review-form-suspected-theft.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReviewFormSuspectedTheftComponent {
  public form = input.required<FormGroup<IncidentFormControls>>();
}
